import { HubVisitorFeatureToggle } from '../../models/hub/hub.visitor.feature.toggle';
import { VisitorSettingsCommand } from '../pagination.query.command';
import { HubVisitorDataSource } from 'models/hub/hub.visitor.data.source';
import {StyleCommand, StyleModel} from "../hub/style.command";

export class AllFrontendSettingsCommand {
    public customSettings: VisitorSettingsCommand;
    public toggle: HubVisitorFeatureToggle;
    public regions: HubVisitorRegion[];
    public dataSource: HubVisitorDataSource;
    public style: StyleCommand | StyleModel;
    public placeCategories: any;
}

export class HubVisitorRegion {
    public id: string;
    public name: string;
    public cities: HubVisitorResionCity[];
    public tours: any;
}

export class HubVisitorResionCity {
    public id: string;
    public cityTitle: string;
    public cityImage: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/visitor/all.frontend.settings.command.ts